import { useGetInteractiveLessonParams } from './activity-builder.hooks';
import { useFeatureCanAccessStudents } from 'approot/feature-flags/use-feature-can-access-students';

export const useActivityBuilderFlags = () => {
  const canAccessStudents = useFeatureCanAccessStudents();
  const { isPublic } = useGetInteractiveLessonParams();
  return {
    activityBuilderRespondFlag: !isPublic && canAccessStudents,
  };
};
